"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useGetTrackerParams = void 0;

var _environments = require("../../../environments");

var _useGetWidgetName = require("./useGetWidgetName");

var _useGetWhitelabelName = require("./useGetWhitelabelName");

var _useGetSearchParams = require("./useGetSearchParams");

var _tracker = require("../../../utils/tracker");

var useGetTrackerParams = function useGetTrackerParams(widgetNameParam, whitelabelNameParam) {
  var whitelabelName = (0, _useGetWhitelabelName.useGetWhitelabelName)();
  var partnerName = !whitelabelName || whitelabelName === '' ? whitelabelNameParam || '' : whitelabelName;
  var searchParams = (0, _useGetSearchParams.useGetSearchParams)();
  var trackerSearchParams = (0, _tracker.convertSearchParamsForTracking)(searchParams);
  var widgetName = (0, _useGetWidgetName.useGetWidgetName)() || widgetNameParam;
  var widgetNameForTracking = widgetName && searchParams ? (0, _tracker.getWidgetNameInSnakeCase)(widgetName, searchParams.search_type) : undefined;
  var isTrackingEnabled = widgetNameForTracking && _environments.environment.production;
  return {
    isTrackingEnabled: !!isTrackingEnabled,
    widgetName: widgetNameForTracking,
    partnerName: partnerName,
    searchParams: trackerSearchParams
  };
};

exports.useGetTrackerParams = useGetTrackerParams;